export function staffServiceAnalytics(state = [], action) {
  switch (action.type) {
    case "STAFF_SERVICE_ANALYTICS_FETCH_DATA_SUCCESS":
      return action.staffServiceAnalytics;
    default:
      return state;
  }
}
